"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
require("core-js/modules/es.array.includes");
require("core-js/modules/es.array.reduce");
require("core-js/modules/es.string.includes");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _get = _interopRequireDefault(require("lodash/get"));
var _isNil = _interopRequireDefault(require("lodash/isNil"));
var _getDataByDataSource = require("./getDataByDataSource");
function getDictionaryValue(product, componentConfig, config, dictionaries) {
  var values = (0, _get.default)(product, componentConfig.property);
  var dataSources = config.dataSources,
    properties = config.properties,
    configDictionaries = config.dictionaries;
  if ((0, _isNil.default)(values) || !values.length) {
    return componentConfig.defaultValue;
  }
  var value = Array.isArray(values) ? values : [values];
  var dataSource = dataSources[componentConfig.dataSource || properties[componentConfig.property].dataSource];
  var data = (0, _getDataByDataSource.getDataByDataSource)(dataSource, dictionaries, configDictionaries);
  return data === null || data === void 0 ? void 0 : data.reduce(function (out, item) {
    if (value !== null && value !== void 0 && value.includes(item.value)) {
      out.push(item.label);
    }
    return out;
  }, []).join(', ');
}
var _default = getDictionaryValue;
exports.default = _default;